import React from 'react';
import PropTypes from 'prop-types';

import AllocateResultList from './AllocateResultList';
import TextAmount from 'components/text/TextAmount';

const AllocateTab = ({ data }) => {
  if (!data || Object.keys(data).length === 0){
    return (
      <div/>
    );
  }

  console.log("data", data);
  let result = data;

  return (
    <div>    
      <div className="grid">              
        <div className="col s12of12">            
            <AllocateResultList title={"Kröfuhafi"} data={result.creditorLines} />
            {result.currentSum &&  <h6>Ofgreitt til kröfuhafa: <TextAmount value={result.currentSum.paymentsCreditorOverPaid}/></h6>}
        </div>   
        <div className="col s12of12">            
            <AllocateResultList title={"Lögmaður"} data={result.lawyerLines} />
            {result.currentSum &&  <h6>Ofgreitt til kröfuhafa: <TextAmount value={result.currentSum.paymentsCreditorOverPaid}/></h6>}
        </div>   
      </div>      
    </div>
  );
};

AllocateTab.propTypes = {
  data: PropTypes.object,
};

export default AllocateTab;
